import {useInView} from 'react-intersection-observer';

export default function InfiniteScrollContainer({children, onBottomReached, className}) {
  const {ref} = useInView({
    rootMargin: '50px',
    onChange(inView) {
      if (inView) {
        onBottomReached();
        console.log('bottom reached');
      }
    },
  });

  return (
    <div className={className}>
      {children}
      <div ref={ref} />
    </div>
  );
}
